module.exports = __webpack_public_path__ + "img/image8.20ae30ba.png";